import React from 'react';
import { StyledTopLabel, StyledTopLabels } from './index.style';

const TopLabels = ({ marksList, minValue, maxValue }) => {
  const labelsToRender = marksList.filter(
    (_, idx) => idx !== 0 && idx !== marksList.length - 1,
  );
  return (
    <StyledTopLabels>
      {labelsToRender.map(
        (mark) =>
          !!mark.topMarkLabels && (
            <StyledTopLabel
              key={mark.value}
              left={`${
                ((mark.value - minValue) / (maxValue - minValue)) * 100
              }%`}
              top={0}
              // eslint-disable-next-line react/no-danger
              dangerouslySetInnerHTML={{ __html: mark.topMarkLabels }}
            />
          ),
      )}
    </StyledTopLabels>
  );
};

export default TopLabels;
